<template>
    <div>

        <div class="modal fade" id="calendarEventBoxModal" tabindex="-1" aria-labelledby="calendarEventBoxModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="px-4 py-2">
                        <div class="modal-icon text-center mt-2">
                            <span class="round-icon bg-lightyellow">
                                <i class="fa fa-bell text-primary" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="modal-body">
                            <h3 class="m-0 mb-2 text-primary text-center">Gegevens klant</h3>
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 35%;" class="strong">Naam</td>
                                    <td style="width: 65%;" class="strong">{{ this.item.name }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Adres</td>
                                    <td>{{ this.item.street }} {{ this.item.house_nr }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Postcode</td>
                                    <td>{{ this.item.zipcode }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Plaats</td>
                                    <td>{{ this.item.city }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Telefoon</td>
                                    <td>{{ this.item.phone }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">E-mailadres</td>
                                    <td>{{ this.item.email }}</td>
                                </tr>
                            </table>
                            <h3 class="pt-4 mb-2 text-primary text-center">Afspraak gegevens</h3>
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 35%;" class="strong">Locatie</td>
                                    <td style="width: 65%;">{{ this.item.location }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gewenste datum</td>
                                    <td>{{ this.item.date }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gewenste tijd</td>
                                    <td>{{ this.item.time }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../../event-bus";

    export default {
        name: 'planning-form-request-modal',
        components: {},
        props: {},
        data() {
            return {
                item: {}
            }
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {

            this.calendarEventBoxModal = new bootstrap.Modal(document.getElementById('calendarEventBoxModal'));

            EventBus.$on('showCalendarEvent', (item) => {
                this.item = item;
                this.calendarEventBoxModal.show();
            });
        },
        created() {},
    }
</script>
